import React from 'react';

import styled from '@emotion/styled';

import { FormSubmitButton } from '../../../components/Button/PrimaryButton';
import { FormComponent } from '../../../components/FormCom/FormComponent';
import {
  SelectField,
  TextInputField,
} from '../../../components/FormCom/FormField';
import { ModalContentWrapper } from '../../../components/Modal/ModalContentWrapper';
import useCreateArea from '../../../hooks/warehouse/useCreateArea';
import useWarehouseArea from '../../../hooks/warehouse/useWarehouseArea';
import {
  CreateAreaDataType,
  CreateAreaInitialValues,
  CreateAreaSchema,
} from '../../../models/warehouse/createArea.model';
import { getAreaCode } from '../../../utils/utils';

const CreateAreaPriceModal = () => {
  const { createArea, loading } = useCreateArea();
  const { listOfWarehousesArea } = useWarehouseArea();

  const onSubmit = (values: CreateAreaDataType, actions: any) => {
    // console.log(values);

    createArea({
      areaId: getAreaCode(listOfWarehousesArea!, values.areaId),
      price: Number(values.price),
    });

    // if (resetInputFields) {
    actions.resetForm(CreateAreaInitialValues);
    // }
  };

  return (
    <ModalContentWrapper title={'Create Area Price'} width={'28rem'}>
      <Container>
        <FormComponent
          initialValues={CreateAreaInitialValues}
          schema={CreateAreaSchema}
          onSubmit={onSubmit}
        >
          <SelectField label="Area Name" name="areaId">
            <option
              disabled
              value=""
              className="select-with-disabled-selected-option"
            >
              {'Select Area'}
            </option>
            {listOfWarehousesArea &&
              listOfWarehousesArea.map((data: any, index: number) => (
                <option key={index}>{data.name}</option>
              ))}
          </SelectField>

          <TextInputField
            label="Price"
            name="price"
            type="text"
            placeholder="Price"
            className="full"
          />

          <FormSubmitButton
            type="submit"
            showIcon={loading}
            className="placeLeft"
          >
            Create Price
          </FormSubmitButton>
        </FormComponent>
      </Container>
    </ModalContentWrapper>
  );
};

export default CreateAreaPriceModal;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
